import {RefObject, useEffect, useState} from 'react'

interface UseOnScreenOptions {
  topOffset?: string // e.g. '100px' or '-50px'
}

export function useOnScreen(
  ref: RefObject<HTMLElement>,
  options?: UseOnScreenOptions,
) {
  const [isOnScreen, setIsOnScreen] = useState(false)

  useEffect(() => {
    const topOffset = options?.topOffset ?? '0px'

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsOnScreen(entry.isIntersecting)
      },
      {
        rootMargin: `${topOffset} 0px 0px 0px`,
      },
    )

    const currentElement = ref.current
    if (currentElement) {
      observer.observe(currentElement)
    }

    return () => {
      observer.disconnect()
    }
  }, [ref, options?.topOffset])

  return isOnScreen
}
